import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface ComponentProps {
  urlPrefix: string;
}

const Payment = () => {
  const location = useLocation();
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (!hasNavigated.current) {
      hasNavigated.current = true;
      const fullUrl = `/payment-page${location.pathname}${location.search}${location.hash}`;
      window.location.href = fullUrl;
    }
  }, []);

  return null;
}

export default Payment;
